import { MsalProvider, useIsAuthenticated } from "@azure/msal-react";
import { Routes, Route, Navigate, Outlet, useNavigate } from "react-router-dom";
import { IPublicClientApplication } from "@azure/msal-browser";
import { useDispatch, useSelector } from "react-redux";
import { StyledEngineProvider } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { Dispatch } from "redux";

import { createFetchWithAuth } from "./utils/fetchWithAuth";
import { AppState } from "./store/reducer";
import Login from "./views/Login/Login";
import Home from "./views/Home/Home";
import "./styles.scss";

const PrivateRoutes = () => {
	const isAuthenticatedRedux: boolean = useSelector((state: AppState) => state.isAuthenticated);
	const isAuthenticatedMsal = useIsAuthenticated();

	const isAuthenticated = isAuthenticatedRedux && isAuthenticatedMsal;

	return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

type AppProps = {
	pca: IPublicClientApplication;
};

function App({ pca }: AppProps) {
	const isAuthenticatedRedux: boolean = useSelector((state: AppState) => state.isAuthenticated);
	const navigate = useNavigate();

	const dispatch: Dispatch<any> = useDispatch();

	useEffect(() => {
		window.fetch = createFetchWithAuth(navigate, dispatch);
	}, [navigate]);

	return (
		<StyledEngineProvider injectFirst>
			<MsalProvider instance={pca}>
				<>
					<Routes>
						<Route
							path="/"
							element={isAuthenticatedRedux ? <Navigate to="/home" /> : <Login />}
						/>
						<Route element={<PrivateRoutes />}>
							<Route
								path="/home"
								Component={Home}
							/>
						</Route>
					</Routes>
				</>
			</MsalProvider>
		</StyledEngineProvider>
	);
}

export default App;
